// extracted by mini-css-extract-plugin
module.exports = {"input-type":"InputText_input-type__mi0X4","input":"InputText_input__YOv_v","error":"InputText_error__J4gmW","has-error":"InputText_has-error__k0Fh5"};